import {
	faBabyCarriage as fasBabyCarriage,
	faBuildingColumns as fasBuildingColumns,
	faCalculator as fasCalculator,
	faCommentsDollar as fasCommentsDollar,
	faCreditCard as fasCreditCard,
	faDisplayChartUpCircleDollar as fasDisplayChartUpCircleDollar,
	faHeartPulse as fasHeartPulse,
	faHouseChimneyWindow as fasHouseChimneyWindow,
	faMagnifyingGlassDollar as fasMagnifyingGlassDollar,
	faPersonCane as fasPersonCane,
	faPiggyBank as fasPiggyBank,
	faSackDollar as fasSackDollar,
	faShieldCheck as fasShieldCheck,
	faWallet as fasWallet,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import type { ReactNode } from "react";

export interface CalculatorGridTileSubMenuItem {
	title: string;
	url: string;
}
export interface CalculatorGridTile {
	name: string;
	clickAction: string;
	title: string | ReactNode;
	url: string;
	icon: string; // Still necessary for widget version
	faIcon?: IconDefinition;
	new: boolean;
	optional?: boolean;
	subMenuOptions?: CalculatorGridTileSubMenuItem[];
}

export const CALCULATOR_GRID_ITEMS_RETAIL: CalculatorGridTile[] = [
	{
		name: "lakashitel",
		clickAction: "to-lakashitel-landing",
		title: "Lakáshitel",
		url: "/lakashitel-kalkulator/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#jzh",
		faIcon: fasHouseChimneyWindow,
		new: false,
		subMenuOptions: [
			{
				title: "Lakáshitel kalkulátor",
				url: "/lakashitel-kalkulator/",
			},
			{
				title: "Bankmonitor lakáshitel kamatkedvezmény",
				url: "/bankmonitor-lakashitel-kamatkedvezmeny/",
			},
			{
				title: "Lakáshitel felújításra",
				url: "/hitel-lakasfelujitasra/",
			},
			{
				title: "Szabad felhasználású hitel",
				url: "/lakashitel-kalkulator/szabad-felhasznalasu-jelzaloghitel-kalkulator/",
			},
			{
				title: "Hitelkiváltás kalkulátor",
				url: "/lakashitel-hitelkivaltas/",
			},
		],
	},
	{
		name: "szemelyi_kolcson",
		clickAction: "to-szemelyi-kolcson-landing",
		title: "Személyi kölcsön",
		url: "/szemelyi-kolcson/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#szk",
		faIcon: fasWallet,
		new: false,
		subMenuOptions: [
			{
				title: "Személyi kölcsön kalkulátor",
				url: "/szemelyi-kolcson/",
			},
			{
				title: "Autóhitel",
				url: "/autohitel/",
			},
			{
				title: "Személyi kölcsön felújításra",
				url: "/felujitasi-hitel/",
			},
			{
				title: "Prémium személyi kölcsön",
				url: "/szemelyi-kolcson-premium/",
			},
			{
				title: "Nagyösszegű személyi kölcsön",
				url: "/nagyosszegu-szemelyi-kolcson/",
			},
		],
	},
	{
		name: "babavaro_tile",
		clickAction: "to-babavaro-hitel-landing",
		title: "Babaváró hitel",
		url: "/babavaro-hitel/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#babavaro",
		faIcon: fasBabyCarriage,
		new: false,
		subMenuOptions: [
			{
				title: "Babaváró kalkulátor",
				url: "/babavaro-hitel/",
			},
			{
				title: "Gyorsított online babaváró",
				url: "/erste-babavaro-hitel/",
			},
		],
	},
	{
		name: "lakossagi_bankszamla",
		clickAction: "to-lakossagi-bankszamla-landing",
		title: "Bankszámla",
		url: "/bankszamla/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#bszla",
		faIcon: fasCreditCard,
		new: false,
		subMenuOptions: [
			{
				title: "Bankszámla kalkulátor",
				url: "/bankszamla/",
			},
			{
				title: "Ingyenes bankszámlák",
				url: "/bankszamla/ingyenes-bankszamlak/",
			},
			{
				title: "CIB ECO bankszámla",
				url: "/bankszamla/ingyenes-bankszamla-online/",
			},
			{
				title: "CIB ECO Plusz bankszámla",
				url: "/bankszamla/cib-eco-plusz/",
			},
			{
				title: "UniCredit Partner Aktív Nulla bankszámla",
				url: "/bankszamla/ingyenes-bankszamla-nyitas/",
			},
			{
				title: "Raiffeisen Premium Banking bankszámla",
				url: "/raiffeisen-premium-bankszamla/",
			},
			{
				title: "Erste Privilégium 2.0 Partner bankszámla",
				url: "/bankszamla/erste-ingyenes-bankszamla-nyitas/",
			},
		],
	},
	{
		name: "nyugdij_megtakaritas_tile",
		clickAction: "to-nyugdij-landing",
		title: "Nyugdíj-megtakarítás",
		url: "/nyugdij-megtakaritas/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#nyugdij",
		faIcon: fasPersonCane,
		new: false,
		subMenuOptions: [
			{
				title: "Nyugdíj-megtakarítás kalkulátor",
				url: "/nyugdij-megtakaritas/",
			},
			{
				title: "Nyugdíjkalkulátor 2025",
				url: "/nyugdijkalkulator/",
			},
			{
				title: "Megtakarítás gyerekeknek",
				url: "/megtakaritas-gyerekeknek/",
			},
			{
				title: "Befektetési alap",
				url: "/megtakaritasok/befektetesi-alap/",
			},
			{
				title: "Bankbetét",
				url: "/megtakaritasok/bankbetet/",
			},
		],
	},
	{
		name: "biztositas_tile",
		clickAction: "to-biztositas",
		title: "Biztosítás",
		url: "/vedelem/bankmonitor-biztonsag/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#nyugdij",
		faIcon: fasShieldCheck,
		new: false,
		subMenuOptions: [
			{
				title: "Bankmonitor Biztonság",
				url: "/vedelem/bankmonitor-biztonsag/",
			},
			{
				title: "Kockázati életbiztosítás kalkulátor",
				url: "/biztositas/eletbiztositas/",
			},
			{
				title: "Hitelfedezeti életbiztosítás",
				url: "/biztositas/hitelfedezeti-eletbiztositas/",
			},
			{
				title: "Lakásbiztosítás",
				url: "/biztositas/lakasbiztositas-bankmonitor-kedvezmeny/",
			},
			{
				title: "Csoportos személybiztosítás",
				url: "/biztositas/csoportos-szemelybiztositas/",
			},
			{
				title: "Egészségbiztosítás",
				url: "/biztositas/egeszsegbiztositas/",
			},
		],
	},
	{
		name: "hitelkalkulator",
		clickAction: "to-hitel-landing",
		title: <>Hitel&shy;kalkulátor</>,
		url: "/hitelkalkulator/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#hitelkalkulator",
		faIcon: fasCalculator,
		new: false,
	},
	{
		name: "lakastakarek_tile",
		clickAction: "to-lakashitel-landing",
		title: <>Lakás&shy;takarék</>,
		url: "/megtakaritasok/lakastakarek/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack.svg#ltp",
		faIcon: fasPiggyBank,
		new: false,
	},
];

export const CALCULATOR_GRID_ITEMS_CORPORATE: CalculatorGridTile[] = [
	{
		name: "vallalati_hitel",
		clickAction: "to-vallalati-hitel",
		title: "Hitelek",
		url: "/vallalati/hitel/hitelhez-segitjuk-vallalkozasodat/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#advice",
		faIcon: fasDisplayChartUpCircleDollar,
		new: false,
		subMenuOptions: [
			{
				title: "Mennyi hitelt tud felvenni a cégem?",
				url: "/vallalati/hitel/mennyi-hitelt-kaphat-a-cegem/",
			},
			{
				title: "100 millió forint feletti hitel",
				url: "/vallalati/hitel/100-millio-feletti/",
			},
		],
	},
	{
		name: "hitelkalkulator",
		clickAction: "to-vallalkozoi-hitel-kereso",
		title: <>Vállalati hitelkereső</>,
		url: "/vallalati/hitel/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#calculator",
		faIcon: fasMagnifyingGlassDollar,
		new: false,
	},
	{
		name: "kkv_bankszamla",
		clickAction: "to-vallalkozoi-bankszamla",
		title: <>Bankszámlák</>,
		url: "/vallalati/bankszamla/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#account",
		faIcon: fasBuildingColumns,
		new: false,
		subMenuOptions: [
			{
				title: "Vállalkozói bankszámlák",
				url: "/vallalati/bankszamla/",
			},
			{
				title: "Ingyenes Raiffeisen Vállalkozói bankszámla",
				url: "/vallalati/bankszamla/ingyenes-vallalkozoi-bankszamla/",
			},
			{
				title: "Ingyenes UniCredit FixPont Vállalkozói bankszámla",
				url: "/vallalati/bankszamla/vallalkozoi-szamla-unicredit/",
			},
		],
	},
	{
		name: "vallalati_tanacsadas",
		clickAction: "to-vallalati-tanacsadas",
		title: "Vállalati tanácsadás",
		url: "/vallalati/vallalati-tanacsadas/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#advice",
		faIcon: fasCommentsDollar,
		new: false,
	},
	{
		name: "ceges_egeszsegbiztositas",
		clickAction: "to-ceges-egeszsegbiztositas",
		title: <>Vállalati egészség&shy;biztosítás</>,
		url: "/vallalati/vallalati-egeszsegbiztositas/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#insurance",
		faIcon: fasHeartPulse,
		new: false,
	},
	{
		name: "szechenyi_kartya",
		clickAction: "to-szechenyi-kartya",
		title: "Széchenyi hitel",
		url: "/vallalati/hitel/szechenyi-hitel/",
		icon: "/wp-content/themes/bankmonitor/img/menu/icon-set-stack-corporate.svg#szechenyi",
		faIcon: fasSackDollar,
		new: false,
	},
];
